<template>
    <div v-if="!settings.is_sourcing_mode"
        class="border-keyline-secondary pb-4 at1440:mb-0 at1440:border at1440:p-16 at1440:pt-10 at1440:pr-4 at1440:border-b-0"
    >
        <h3 class="type-secondary py-4 text-2xl font-bold">
            {{ $t(title) }}
        </h3>
        <ul class="text-base at1440:grid at1440:grid-cols-3 print:!text-xs">
            <li v-for="row in primaryAttributes">
                <Divider class="block at1440:hidden" />
                <div class="py-3 pl-0 grid grid-cols-2 at1440:block">
                    <div class="at1440:font-medium">
                        {{ row.label }}
                    </div>
                    <div class="type-secondary break-words">
                        {{ row.value ? row.value : "–" }}
                    </div>
                </div>
            </li>
            <li v-for="row in newAttributes">
                <Divider class="block at1440:hidden" />
                <div class="py-3 pl-0 grid grid-cols-2 at1440:block">
                    <div class="at1440:font-medium">
                        {{ row.type.label }}
                    </div>
                    <div class="type-secondary">
                        {{ row.value ? row.value : "–" }}
                    </div>
                </div>
            </li>
        </ul>
        <slot />
    </div>
    
    <div
        v-else
        class="border-keyline-secondary pb-4 !border-b p-8"
    >
        <h5 class="font-bold pb-4">
            {{ $t(title) }}
        </h5>
        <ul class="text-sm print:!text-xs">
            <li v-for="row in primaryAttributes" class="hover:bg-gray-tier-5">
                <Divider />
                <div class="py-2 pl-0 grid grid-cols-3">
                    <div class="px-2 col-span-1 font-medium">
                        {{ row.label }}
                    </div>
                    <div class="px-2 col-span-2 type-secondary break-words">
                        {{ row.value ? row.value : "–" }}
                    </div>
                </div>
            </li>
            <li v-for="row in newAttributes" class="hover:bg-gray-tier-5">
                <Divider />
                <div class="py-2 pl-0 grid grid-cols-3">
                    <div class="px-2 col-span-1 font-medium">
                        {{ row.type.label }}
                    </div>
                    <div class="px-2 col-span-2 type-secondary">
                        {{ row.value ? row.value : "–" }}
                    </div>
                </div>
            </li>
        </ul>
        <slot />
    </div>
</template>

<script setup>
import { computed } from "vue";
import { Divider } from "@/Components";
import { useUser } from "@/Composables";
import _ from "lodash";

const { settings } = useUser();
const props = defineProps({
    rows: Array,
    title: String,
    attributes: Object,
    primaryAttributes: Array,
    finishInfo: Object,
    sortByLabel: {
        type: Boolean,
        default: false
    }
});
const newAttributes = computed(() => {
    const attributes = _.get(props, "rows", []).map((row) => props.attributes[row]);
    
    if (props.sortByLabel) {
        return attributes.sort((a, b) => a?.type?.label?.localeCompare(b?.type?.label) || 0);
    }
    
    return attributes;
});
</script>
